import axios from 'axios'

export const getForm = async () => {
  return fetch(`/ajax/getForm.php`).then(html => html.json())
}

export const addForm = async values => {
  // const options = {
  //   method: 'POST',
  //   credentials: 'include',
  //   redirect: 'follow',
  //   headers: {
  //     Accept: 'application/json, text/plain, */*',
  //     'Content-Type': 'application/json'
  //   },
  //   body: JSON.stringify(values)
  // }
  values.AJAX = 'Y'
  const formData = new FormData()
  buildFormData(formData, values)

  return axios
    .post('/ajax/addForm.php', formData)
    .then(response => {
      return response
    })
    .catch(function(error) {
      console.log(error, 'error2')
    })
}

function buildFormData(formData, data, parentKey) {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
    Object.keys(data).forEach(key => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key)
    })
  } else {
    const value = data == null ? '' : data

    formData.append(parentKey, value)
  }
}
